import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserProfileService } from '../services/user-profile.service';

type VerifyState = 'verifying' | 'success' | 'expired' | 'invalid' | 'superseded' | 'error';

@Component({
    selector: 'app-verify-email',
    templateUrl: './verify-email.component.html',
    styleUrls: ['./verify-email.component.scss'],
    standalone: false,
})
export class VerifyEmailComponent implements OnInit {
    state: VerifyState = 'verifying';
    contactEmail: string | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private userProfile: UserProfileService,
    ) {}

    async ngOnInit(): Promise<void> {
        const token = this.route.snapshot.queryParamMap.get('token');
        if (!token) {
            this.state = 'invalid';
            return;
        }

        const result = await this.userProfile.verifyToken(token);
        if (result.ok) {
            this.contactEmail = result.contactEmail ?? null;
            this.state = 'success';
            // Refresh context so the gate disappears if the user is signed in
            // in this same tab.
            this.userProfile.refresh().catch(() => {});
            return;
        }

        switch (result.reason) {
            case 'expired': this.state = 'expired'; break;
            case 'invalid_or_consumed':
            case 'missing_token':
            case 'invalid_body': this.state = 'invalid'; break;
            case 'superseded': this.state = 'superseded'; break;
            default: this.state = 'error'; break;
        }
    }

    continueToApp(): void {
        this.router.navigateByUrl('/flows');
    }
}
